import { CommonModule } from "@angular/common"
import { NgModule } from "@angular/core"
import { FormsModule } from "@angular/forms"

import { SearchPageRoutingModule } from "./search-page-routing.module"
import { SearchPageComponent } from "./search-page.component"

import { SharedComponentsModule } from "../shared-components/shared-components.module"

@NgModule({
    declarations: [SearchPageComponent],
    imports: [CommonModule, SearchPageRoutingModule, SharedComponentsModule, FormsModule],
})
export class SearchPageModule {}
